import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer `;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (codeEntite) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  } else {
    config.headers['ref_entity'] =  null;
  }
  
  const sousEntiteId = localStorage.getItem("sousEntiteId")
  if (sousEntiteId) {
    config.headers['etablissementId'] = `${sousEntiteId}`;
  } else {
    config.headers['etablissementId'] =  null;
  }

  return config;
});

export const getListeCategorie = async () => {
  return await axios.get(
    BASE_URL(`etablissement/recherchercategories`),
    {}
  );
};

export const getListeNiveauParCategorie = async (categorieId) => {
  return await axios.get(
    BASE_URL(`etablissement/listeniveauxnonassocies/${categorieId}`),
    {}
  );
};

